import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import TextInputComponent from "../../atom/Inputs/TextInput";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import { EMAIL_REGEX, getText } from "../../../core/Constant";
import { useDispatch } from "react-redux";

const ResetForm = ({
  onclickcancel = () => {},
  onSuccess = () => {},
  title = "Reset Form",
  buttonText = "Submit",
  placeholder = "Enter student email address",
  onSubmitAction,
}) => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const onEmailChange = (e) => {
    const text = getText(e);
    let isValid = false;
    const reg = EMAIL_REGEX;
    if (text.trim().length > 3) {
      isValid = reg.test(text.trim());
    }
    setEmail(text);
    setIsEmailValid(isValid);
    setEmailError(false);
  };

  const onSubmit = async () => {
    if (isEmailValid) {
      try {
        const result = await dispatch(onSubmitAction({ email }));
        onClean();
        // Call onSuccess callback if the action was successful
        if (result && !result.error && result.payload && result.payload.status_code === 1) {
          onSuccess();
        }
      } catch (error) {
        console.error("Reset action failed:", error);
      }
    } else {
      if (!isEmailValid) {
        setEmailError(true);
      }
    }
  };

  const onClean = () => {
    onclickcancel();
    setEmail("");
    setIsEmailValid(false);
    setEmailError(false);
  };

  return (
    <Box className="login-form-wrap">
      <Box className="login-heading-wrap">
        <p
          style={{
            color: "#4E657C",
            fontWeight: 500,
            fontSize: 20,
            textAlign: "center",
          }}
        >
          {title}
        </p>
      </Box>
      <form>
        <Grid
          spacing={2}
          style={{ display: "flex", justifyContent: "center" }}
          container
        >
          <Grid item xs={10}>
            <TextInputComponent
              isError={emailError}
              error="Please add valid email"
              value={email}
              onchange={onEmailChange}
              type="text"
              label={"Email"}
              placeholder={placeholder}
            />
          </Grid>
          <Grid xs={12} sm={6}>
            <TextButtonComponet
              onButtonClick={() => {
                onSubmit();
              }}
              width="100%"
              text={buttonText}
            />
          </Grid>
          <Grid style={{ height: "50px" }} xs={12}></Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default ResetForm;
